/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:47
 * @LastEditors: cgh
 * @LastEditTime: 2022-08-02 16:19:19
 * @Description: 人员签到信息管理
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const ryqdxxManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/ryqdxx`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/ryqdxx/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/ryqdxx/export`, { responseType: 'blob', params }); }
};
